import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptNavigationItems } from "../adapters/adaptNavigationItem";

const fetchNavigationItems = async () => {
	const response = await cmsClient.get<INavigationItem[]>(
		"/homepage/admin/mobilenavigation/"
	);
	return response.data;
};

const useNavigationItems = () => {
	return useQuery(["navigation-items"], fetchNavigationItems, {
		select: adaptNavigationItems
	});
};

export default useNavigationItems;
